<template>
  <Modal
    :open="isOpen"
    :title="documentTitle"
    size="xl"
    z-class="z-[1200]"
    @close="closeLegalModal"
  >
    <p v-if="loading" class="text-sm text-white/50">Carregando...</p>
    <template v-else-if="doc">
      <p class="text-xs text-white/40">
        Versão {{ doc.version }} · Última atualização: {{ formatDate(doc.created_at) }}
      </p>
      <div v-html="renderLegalMarkdown(doc.content)" />
    </template>
    <p v-else class="text-sm text-red-400">Não foi possível carregar o documento.</p>

    <template #footer>
      <div class="flex justify-end">
        <button
          type="button"
          class="rounded-full border border-white/15 px-4 py-2 text-sm font-semibold text-white/70 transition hover:bg-white/10 hover:text-white"
          @click="closeLegalModal"
        >
          Fechar
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import Modal from '../ui/Modal.vue'
import { useLegalModal } from '../../composables/useLegalModal.js'
import { fetchLegalDocument } from '../../utils/fetchLegalDocument.js'
import { renderLegalMarkdown } from '../../utils/legalMarkdown.js'

const { isOpen, legalDocument, closeLegalModal } = useLegalModal()

const documentTitle = computed(() => {
  if (legalDocument.value === 'terms') return 'Termos de Uso'
  if (legalDocument.value === 'privacy') return 'Política de Privacidade'
  return ''
})

const doc = ref(null)
const loading = ref(false)
const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString('pt-BR') : '')

// Busca a cada abertura (e a cada troca de documento com o modal já aberto)
// em vez de cachear: o texto é editável no app e a landing fica aberta por
// muito tempo numa aba só.
watch([isOpen, legalDocument], async ([open, type]) => {
  if (!open || !type) return
  doc.value = null
  loading.value = true
  try {
    doc.value = await fetchLegalDocument(type === 'terms' ? 'TERMS_OF_USE' : 'PRIVACY_POLICY')
  } finally {
    loading.value = false
  }
})
</script>
